'use client'
import React from 'react'
import { forwardRef } from 'react'

export const BookClosed = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>(function BookClosedImpl(props, forwardRef) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
      ref={forwardRef}>
      <path
        d="M16.9321 4C14.6786 4.00975 12.9954 4.28303 11.7912 4.84487C11.4028 5.02181 11.0405 5.24893 10.7143 5.52011C10.6572 5.56871 10.6115 5.62865 10.5801 5.69591C10.5488 5.76316 10.5326 5.83618 10.5326 5.91005V16.8651C10.5326 16.8902 10.5402 16.9148 10.5545 16.9358C10.5687 16.9567 10.589 16.9731 10.6128 16.9829C10.6366 16.9926 10.6628 16.9953 10.6881 16.9906C10.7135 16.9859 10.7368 16.974 10.7553 16.9564C11.6109 16.1278 13.1124 15.435 16.9334 15.4353C17.2163 15.4353 17.4876 15.3257 17.6876 15.1307C17.8876 14.9357 18 14.6712 18 14.3955V5.03691C18 4.44853 17.5414 4 16.9321 4ZM3.06658 4C2.45863 4 2 4.44853 2 5.03691V14.3955C2 14.6712 2.11241 14.9357 2.31241 15.1307C2.51241 15.3257 2.78366 15.4353 3.06658 15.4353C6.88758 15.435 8.38908 16.1278 9.24473 16.9564C9.2632 16.974 9.28647 16.9859 9.31185 16.9906C9.33722 16.9953 9.36338 16.9926 9.38722 16.9829C9.41106 16.9731 9.43131 16.9567 9.44553 16.9358C9.45975 16.9148 9.46741 16.8902 9.46741 16.8651V5.91005C9.46741 5.83618 9.45119 5.76316 9.41985 5.69591C9.38851 5.62865 9.34285 5.56871 9.28573 5.52011C8.95973 5.2484 8.59593 5.02181 8.20748 4.84487C7.00325 4.28433 5.32006 4.00975 3.06658 4Z"
        fill="parent"
      />
    </svg>
  )
})
